export default __webpack_public_path__ + "static/showme-1a7a223e9784da4a669278f5a3928d96.jpg";